import { useNavigate, useParams } from 'react-router';
import { Page } from '../../components/Layout';
import { EmptyState, ErrorState, LoadingState } from '../../components/states';
import { LoadMore } from '../../components/LoadMore';
import { usePlayerRuns, usePlayerStats, useRuns } from '../../hooks/queries';
import { useAuth } from '../../stores/auth';
import { RunList } from './RunList';
import { useT } from '../../i18n';

export function PlayerRunsPage() {
  const { id } = useParams<{ id: string }>();
  const me = useAuth((s) => s.user?.id);
  const isMe = id === me;
  const navigate = useNavigate();
  const t = useT();
  const stats = usePlayerStats(id!);
  // My own list also shows runs that are still being validated.
  const mine = useRuns(undefined, isMe);
  const theirs = usePlayerRuns(id!, !isMe);
  const q = isMe ? mine : theirs;
  const runs = q.data?.pages.flatMap((p) => p.items) ?? [];
  const title = isMe ? t('My runs') : stats.data ? t('{name}’s runs', { name: stats.data.user.displayName }) : '';

  return (
    <Page>
      <button onClick={() => navigate(-1)} className="mb-2 text-sm font-semibold text-ink-300">
        {t('← Back')}
      </button>
      <h1 className="font-display text-3xl font-bold uppercase" data-testid="player-runs-title">
        {title}
      </h1>
      <div className="mt-4">
        {q.isPending ? (
          <LoadingState />
        ) : q.isError && !q.data ? (
          <ErrorState error={q.error} onRetry={() => q.refetch()} />
        ) : runs.length === 0 ? (
          <EmptyState icon="🏃" title={t('No runs yet')} />
        ) : (
          <RunList runs={runs} />
        )}
        <LoadMore hasMore={!!q.hasNextPage} loading={q.isFetchingNextPage} onLoad={() => void q.fetchNextPage()} />
      </div>
    </Page>
  );
}
